import React from "react";
import { Container, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { FaCheckCircle } from "react-icons/fa";

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 70vh;
  padding: 24px 16px;
  text-align: center;
`;

const StyledButton = styled(Button)`
  width: min(100%, 280px);
  min-height: 46px;
  font-size: 18px;
  border-radius: 999px;
`;

const PrimaryLink = styled(Link)`
  color: white;
  width: min(100%, 280px);

  &:hover {
    color: white;
    text-decoration: none;
  }
`;

const SecondaryLink = styled(Link)`
  color: inherit;
  width: min(100%, 280px);

  &:hover {
    color: inherit;
    text-decoration: none;
  }
`;

const StyledCheckMark = styled(FaCheckCircle)`
  color: #2ab56f;
  font-size: 70px;
  margin: 12px 0 18px;
`;

const Lead = styled.p`
  max-width: 580px;
  font-size: 1rem;
  line-height: 1.9;
  color: #3d3d3d;
  margin-bottom: 14px;
`;

const CodeBox = styled.div`
  width: min(100%, 480px);
  background: #fff8e8;
  border: 1px solid #f0d6a6;
  border-radius: 16px;
  padding: 18px 16px;
  margin: 10px 0 18px;
`;

const RecoveryCode = styled.div`
  font-size: clamp(1.2rem, 5vw, 1.7rem);
  font-weight: 900;
  letter-spacing: 0.12em;
  color: #7b5b25;
  margin-top: 10px;
  word-break: break-all;
`;

const Note = styled.p`
  max-width: 560px;
  color: #666;
  font-size: 0.95rem;
  line-height: 1.7;
  margin-bottom: 20px;
`;

const MemberRegisterCompleteView = () => {
  const location = useLocation();
  const recoveryCode = location.state?.recoveryCode;

  return (
    <StyledContainer>
      <h2>会員登録が完了しました</h2>
      <StyledCheckMark />
      <Lead>
        コメントや掲示板の反応ができる準備が整いました。
        <br />
        次は最初の夢を投稿して、掲示板を動かしてみましょう。
      </Lead>
      <CodeBox>
        <div style={{ fontWeight: 700, color: "#7b5b25" }}>復旧コード</div>
        <RecoveryCode>{recoveryCode || "----"}</RecoveryCode>
      </CodeBox>
      <Note>
        パスワードを忘れたときに使う大事なコードです。
        <br />
        スクリーンショットやメモなど、あとで見返せる形で控えてください。
      </Note>
      <PrimaryLink to="/Register">
        <StyledButton
          variant="primary"
          className="w-100 text-center d-flex align-items-center justify-content-center"
          style={{
            fontSize: "1.05rem",
            color: "#ffffff",
            borderColor: "transparent",
          }}
        >
          最初の夢を投稿する
        </StyledButton>
      </PrimaryLink>
      <div style={{ height: "12px" }} />
      <SecondaryLink to="/MyPage">
        <StyledButton
          variant="outline-primary"
          className="w-100 text-center d-flex align-items-center justify-content-center"
          style={{ fontSize: "1rem" }}
        >
          先にマイページを見る
        </StyledButton>
      </SecondaryLink>
    </StyledContainer>
  );
};

export default MemberRegisterCompleteView;
